import { inject, Injectable, signal } from '@angular/core';
import { LoggerService } from '../log-level.service';
import { IProgramaPermiso } from '@/interface/general/IProgramaPermiso.interface';

export type PermissionAction =
  | 'Ejecutar'
  | 'Leer'
  | 'Grabar'
  | 'Borrar'
  | 'Editar'
  | 'Consultar';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  public logger = inject(LoggerService);
  private programasPermisos = signal<IProgramaPermiso[]>([]);

  // Método para establecer los permisos del usuario (vendría de tu API)
  setProgramasPermisos(permisos: IProgramaPermiso[]): void {
    this.programasPermisos.set(permisos);
  }

  // Verificar si el usuario tiene un permiso específico para un programa
  // El formato del permiso es: "programa:accion" (ej: "querylupas:Grabar")
  hasPermission(permissionKey: string): boolean {
    const [programa, accion] = permissionKey.split(':');

    if (!programa || !accion) {
      console.warn('Formato de permiso incorrecto. Usa "programa:accion"');
      return false;
    }

    const programaPermiso = this.programasPermisos().find(
      (p) => p.CodPrograma.toLowerCase() === programa.toLowerCase()
    );

    if (!programaPermiso) {
      return false;
    }

    return programaPermiso[accion as PermissionAction] === true;
  }

  // Obtener todos los programas con permisos
  getProgramasPermisos(): IProgramaPermiso[] {
    return this.programasPermisos();
  }
}
